// extracted by mini-css-extract-plugin
export default {"buttonContainer":"EditButton_buttonContainer__5MGPu","editButton":"EditButton_editButton__nc3aY"};